import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheService } from '../services/cache.service';

const CACHABLE_URL = '/domain';

export const cacheCartoafInterceptor: HttpInterceptorFn = (req, next) => {
  const cache = inject(CacheService);

  if (!isRequestCachable(req, cache)) {
    return next(req);
  }

  const cachedResponse = cache.get(req);
  if (cachedResponse !== null) {
    return of(new HttpResponse(cachedResponse));
  }

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        cache.put(req, event);
      }
    })
  );
};

function isRequestCachable(request: HttpRequest<any>, cache: CacheService): boolean {
  return (
    request.method === 'GET' &&
    request.url.indexOf(CACHABLE_URL) > -1 &&
    cache.allowCache
  );
}
